import { Pipe, PipeTransform } from '@angular/core';
import { VorgangsTyp } from '../../domain/model/vorgangsTyp';

@Pipe({
    name: 'zuweisungGelesenReadable',
    standalone: false,
})
export class ZuweisungGelesenReadablePipe implements PipeTransform {

    transform(value: boolean, aufgabenTyp: VorgangsTyp): any {
        if (value) {
            switch (aufgabenTyp) {
                case VorgangsTyp.AUFGABE:
                case VorgangsTyp.ABWURFPUNKTE_AUFGABE:
                    return 'erledigt';
                default:
                    return 'zur Kenntnis genommen';
            }
        } else {
            return 'offen';
        }
    }

}
